"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
let PinButtonComponent = class PinButtonComponent {
    constructor() {
        this._isPinned = false;
        this._wasPinned = false;
        this.autoUnpinTime = 5;
        this.onUnpin = new core_1.EventEmitter();
    }
    get isPinned() {
        return this._isPinned;
    }
    ngOnInit() {
        setTimeout(() => {
            if (!this._isPinned && !this._wasPinned) {
                this.onUnpin.emit();
            }
        }, this.autoUnpinTime * 1000);
    }
    onBtnClick() {
        this._isPinned = !this._isPinned;
        if (this._isPinned) {
            this._wasPinned = true;
        }
        else if (this._wasPinned) {
            this.onUnpin.emit();
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PinButtonComponent.prototype, "autoUnpinTime", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], PinButtonComponent.prototype, "onUnpin", void 0);
PinButtonComponent = __decorate([
    core_1.Component({
        selector: 'pin-button',
        templateUrl: './@inax/commonUi/src/expandablePanel/pinButtonComponent/pinButton.component.html',
        styleUrls: ['./@inax/commonUi/src/expandablePanel/pinButtonComponent/pinButton.component.css']
    })
], PinButtonComponent);
exports.PinButtonComponent = PinButtonComponent;
